import { ChangeDetectorRef ,ViewRef,Component, EventEmitter, Input, OnInit, Output,ViewChild,ElementRef } from '@angular/core'
import { Stringable, StringableValues } from '../../../../common/stringable.decorator'
import { JSONRpcResponse } from '../../../../Interfaces/JSONRpcResponse'
import { DialogService, StateService,DossierService,
IaService
 } from '../../../../services'
//import { ClipboardService } from 'ngx-clipboard'

import {
	Observable,
	BehaviorSubject,	
} from "rxjs";

const KEY = 'ia'

@Component({
  selector: 'atyl-ai',
  templateUrl: './ia.component.html',
  styleUrls: ['./ia.component.scss']
})
@Stringable({
  path: 'views/partials/content/general/ia',
  key: KEY,
})
export class IaComponent implements OnInit {

  @Input() loading:BehaviorSubject<any>=new BehaviorSubject<any>(null);
  
  @StringableValues(KEY) strings: any
  
  ia:any;
  ias:any[]=[];

  loader:boolean=false;

  @Input() searchInput:string="";
  
  @ViewChild('itemList', { read: undefined, static: undefined }) itemList: ElementRef<HTMLInputElement>
  
  myScrollVariable:number=0;
  
  constructor(
    private changeDetector: ChangeDetectorRef,
    private stateService: StateService,
    private dialogService: DialogService,
    private dossierService: DossierService,
    private changeDetectorRef: ChangeDetectorRef,
    private iaService: IaService,
	//private _clipboardService: ClipboardService
  ) { }

  ngOnInit() {
	  
	  this.loading.subscribe((loading)=>{
			  if (loading) {
				this.loader=true;
				this.loadIA();
			  }
		 });
	  
	 this.stateService.ia.subscribe((ia) => {
		 					if (ia) {
		 						this.ia=ia;

	 							}
    });
    
  }
  
   loadIA() {
	 //  console.log(" IAComponent load ");	
	   
	   let _opts:any={
		   
	   }
	  
	   this.ias=[];
	   this.iaService.list(_opts).subscribe(
		   (res: JSONRpcResponse) => {
				console.log("IAComponent loaded",res);
				if (res.result 
					&& res.result!=undefined
				) {
					this.ias=res.result;
					console.log("IAComponent loaded",this.itemList);
					/*if (this.itemList!=undefined 
						&& this.itemList.nativeElement!=undefined)
							this.myScrollVariable=0;*/
					this._scrollTop();
				}
				this.loader=false;	
				this.detectChanges();
			}
	   );
	   	
   }
  
   detectChanges() {
        setTimeout(() => {
            if (this.changeDetectorRef && !(this.changeDetectorRef as ViewRef).destroyed) {
                this.changeDetectorRef.detectChanges()
            }
        })
    }
    
	copyData(event:any,dataTxt:any,isHTML:boolean=false) {
			
			if (typeof (navigator.clipboard) == 'undefined') {
			    console.log('navigator.clipboard');
			    var textArea = document.createElement("textarea");
			    textArea.value = dataTxt;
			    textArea.style.position = "fixed";  //avoid scrolling to bottom
			    document.body.appendChild(textArea);
			    textArea.focus();
			    textArea.select();
			
			    try {
			        var successful = document.execCommand('copy');
			        var msg = successful ? 'successful' : 'unsuccessful';
			        console.log(msg);
			    } catch (err) {
			        console.log('Was not possible to copy te text: ', err);
			    }
			
			    document.body.removeChild(textArea)
			    return;
			}
			if (!isHTML) {	
			navigator.clipboard.writeText(dataTxt).then(function () {
			    console.log(`successful!`);
			}, function (err) {
			   console.log('unsuccessful!', err);
			});
			
			navigator.clipboard.writeText(dataTxt).then().catch(e => console.error(e));
			} else {
			
			//	this._clipboardService.copyFromContent(dataTxt)
			}
	}
	
	send(event:any) {
		if (this.searchInput.length>0) {
			this.loader=true;	
			this.iaService.requete(this.searchInput).subscribe(
				   (res: JSONRpcResponse) => {
						console.log("IAComponent send",res);
						if (res.result 
							&& res.result!=undefined
							&& Array.isArray(res.result)
						) {
							for(let i=0;i<res.result.length;i++) {
								this.ias.unshift(res.result[i]);
								
							}
							/*if (this.itemList!=undefined 
								&& this.itemList.nativeElement!=undefined)
								this.myScrollVariable=0;*/
								this._scrollTop();
								//	this.itemList.nativeElement.scrollTop=0;
							
						}
						this.loader=false;	
						this.detectChanges();
					}
			   );
			}   
	}
	
	getServices() {
		let s:string[]=[];
    //		console.log("IAComponent service",this.ia);
		if (this.ia!=undefined 
			&& this.ia.services!=undefined 
			 ) {
				Object.keys(this.ia.services).forEach((sv:any)=>{
					if (this.ia.services[sv]!=undefined) {
						let ssv:any=this.ia.services[sv];
						if (ssv.label!=undefined)
							s.push(ssv.label);	
					}
				});
				
					
			
		}
		return s.join(", ");
	}
	
	remove(event:any,id:any) {
			if (id!=undefined) {
				this.loader=true;	
				this.iaService.remove(id).subscribe(
					   (res: JSONRpcResponse) => {
							console.log("IAComponent remove",res);
							if (res.result 
								&& res.result!=undefined
								
							) {
								
								this.loadIA();
								
							} else {
								this.loader=false;	
								this.detectChanges();
								}
						}
				   );
				}   
		}

   _scrollTop() {
	document.getElementById('itemList').scrollTo(0,0);
   }

}
